// A stable, deterministic key for a field, derived from its outer ring. Lets us attach a saved
// work-session to "the field as drawn" without any persistent field id (LPIS ids are unstable
// across fetches; drawn fields have none). Coordinates are rounded to ~1e-6 deg (~0.1 m) so tiny
// float jitter doesn't change the key, and an explicit closing vertex (first === last) is dropped
// so open/closed ring representations hash equally. NOT rotation-invariant by design: a field
// re-drawn starting at a different vertex is a different plan.

import type { LonLat } from './types';

export function fieldKey(ring: LonLat[]): string {
  const pts = ring.map(([lon, lat]) => `${lon.toFixed(6)},${lat.toFixed(6)}`);
  if (pts.length > 1 && pts[0] === pts[pts.length - 1]) pts.pop();
  const canon = pts.join(';');
  // FNV-1a 32-bit — fast, dependency-free, good enough for a content key.
  let h = 0x811c9dc5;
  for (let i = 0; i < canon.length; i++) {
    h ^= canon.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}
